// Déduplication partagée des événements (WebSocket + Web Push + reconnexion/resync).
// Un même event_id (ex: "order:<id>:PRETE", "sr:<id>") ne déclenche qu'une seule alerte.
const seen = new Map();
const TTL = 6 * 60 * 60 * 1000;

export function acceptEvent(eventId) {
  if (!eventId) return true;
  const now = Date.now();
  for (const [id, t] of seen) if (now - t > TTL) seen.delete(id);
  if (seen.has(eventId)) return false;
  seen.set(eventId, now);
  return true;
}
